/// Replaces the byline on feedback-typed posts. Shows the star
/// rating, the level (display name resolved from the registry),
/// "From a player", and a relative age. Carries no author
/// identifier — the submitter UID lives privately in
/// `webFeedbackOwners/{postId}` and never reaches this component.

import { findLevel } from '../data/loadLevel'
import type { Timestamp } from 'firebase/firestore'

export function DevBlogFeedbackHeader(props: {
  rating: number
  levelId: string | null
  createdAt: Timestamp | null
}) {
  const level = props.levelId ? findLevel(props.levelId) : null
  const levelLabel = level?.displayName ?? props.levelId
  return (
    <div className="flex min-w-0 items-center gap-2 text-[11px] text-slate-400">
      <span
        className="rounded bg-amber-400/15 px-1.5 py-0.5 font-semibold text-amber-200 ring-1 ring-amber-400/30"
        title={`${props.rating} out of 5`}
      >
        {'★'.repeat(props.rating)}
        <span className="text-amber-300/40">{'★'.repeat(Math.max(0, 5 - props.rating))}</span>
      </span>
      {levelLabel && <span className="truncate text-slate-300">{levelLabel}</span>}
      <span className="text-slate-500">·</span>
      <span className="italic text-slate-500">From a player</span>
      {props.createdAt && (
        <>
          <span className="text-slate-500">·</span>
          <span className="text-slate-500">{formatAge(props.createdAt.toMillis())}</span>
        </>
      )}
    </div>
  )
}

function formatAge(ms: number): string {
  const diff = Math.max(0, Date.now() - ms)
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'just now'
  if (min < 60) return `${min}m ago`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`
  const day = Math.floor(hr / 24)
  if (day < 30) return `${day}d ago`
  const mon = Math.floor(day / 30)
  if (mon < 12) return `${mon}mo ago`
  const yr = Math.floor(day / 365)
  return `${yr}y ago`
}
